<template>
  <div class="ma-11">
    <v-row justify="start" align="center">
      <v-icon left>home</v-icon>
      <span class="grey--text title">Dashboard</span>
    </v-row>
    <v-divider class="mt-5 mb-11"></v-divider>
    <v-row>
      <item label="Gejala" icon="mdi-bacteria" color="primary" :data="gejala" to="/gejala" />
      <item label="Penyakit" icon="mdi-virus" color="success" :data="penyakit" to="/penyakit" />
      <item
        label="Diagnosa"
        icon="mdi-history"
        color="orange darken-2"
        :data="diagnosa"
        to="/diagnosa"
      />
    </v-row>
  </div>
</template>
<script>
import item from "../components/DashboardItem.vue";
import fs from "@/fb";
export default {
  components: {
    item
  },
  mounted() {
    fs.gejala.onSnapshot(snapshot => {
      this.gejala = snapshot.size;
    });
    fs.penyakit.onSnapshot(snapshot => {
      this.penyakit = snapshot.size;
    });
    fs.diagnosa.onSnapshot(snapshot => {
      this.diagnosa = snapshot.size;
    });
  },
  data() {
    return {
      gejala: 0,
      penyakit: 0,
      diagnosa: 0
    };
  }
};
</script>